module.exports = __webpack_public_path__ + "static/media/soul-cloud-middle.e441ad0d.svg";